import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

import { Distributor } from '@app/api/models';
import { useFetchData, useApi } from '@app/hooks';
import { QueryTable } from '@app/components/common/table';

import { Columns } from './columns';

const DistributorsTable: FC = () => {
  const history = useHistory();
  const api = useApi();
  const [fetchData] = useFetchData<Distributor>({
    method: api.distributors.getDistributors,
  });

  return (
    <QueryTable
      title="Дистрибьюторы"
      columns={Columns}
      fetchData={fetchData}
      onCreateClick={() => history.push('/distributors/create')}
      onRowClick={(row) => {
        if ('id' in row && row.id != null) {
          history.push(`/distributors/edit/${row.id}`);
        }
      }}
    />
  );
};

export default DistributorsTable;
